export const whitesmoke = '#f5f5f5';
export const white = '#ffffff';
export const black = '#333333';
export const darkBlack = '#000000';
export const orange = '#E26A0F';
export const darkOrange = '#bf5708';
export const gray = '#626262';
export const accent = orange;
